import React from 'react';
import ColorPicker from '../../../Components/ColorPicker';

const LedWidgetSettings = ({
	edit,
	setEdit,
	t,
	themeColorKey,
	themeColorValue,
}) => {
	if (edit.type !== 'led') {
		return null;
	}

	return (
		<div className='form-item'>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
				{t.settingsLabels?.color || 'LED On Color'}
			</label>
			<ColorPicker
				id="ledOnColor"
				color={themeColorValue(edit.props, 'color', '#00f0f0')}
				setColor={(c) =>
					setEdit(prev => ({
						...prev,
						props: { ...prev.props, [themeColorKey('color')]: c }
					}))
				}
			/>
		</div>
	);
};

export default LedWidgetSettings;
